<script>
import _unionWith from 'lodash/unionWith'
import _unionBy from 'lodash/unionBy'
import _isEqual from 'lodash/isEqual'

import Layout from '@layouts/main'

import ProductItem from './components/ProductItem'
import SelectDateSize from './components/SelectDateSize'
import TheBanner from './components/TheBanner'
import ViewNull from './components/ViewNull'

import formatDate, { dateDiffInMinutes } from '@utils/format-date'
import formatProductType from '@utils/format-product-type'

export default {
  page() {
    return {
      title: this.merchant.name,
    }
  },
  components: {
    Layout,
    ProductItem,
    SelectDateSize,
    TheBanner,
    ViewNull,
  },
  props: {
    merchant: {
      type: Object,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showIntro: false,
      selectedValue: {
        date: this.$route.params.productType === 'light' || this.$route.params.productType === 'worshipset'
          ? formatDate(new Date(), 'year')
          : formatDate(new Date(), 'month'),
        groupSize: 1,
      },
      maxGroupSize: 10,
      loadedDateTimesData: {},
      loadingDateTimesData: {},
      loadedDateTimesDataGroup: []
    }
  },
  computed: {
    availableDates() {
      const dateTimesData = this.loadedDateTimesData[`groupSize:${this.selectedValue.groupSize}`] || [];
      let availableDates = [];

      switch (this.formatProductType('category', this.$route.params.productType)) {
        case 'light':
          const onlyDatesArrays = Object.values(dateTimesData).map(
            (product) => {
              return product.map((dateTimes) => dateTimes.year)
            }
          );

          onlyDatesArrays.forEach(item => {
            item.forEach(year => {
              availableDates.push(year)
            })
          });
          break;
        case 'activity':
          const dateTimesDataArrays = Object.values(dateTimesData);

          dateTimesDataArrays.forEach(dateTimes => {
            dateTimes.forEach(item => {
              const hasCapacity = Object.values(item.data).every(item => {
                return item.capacity
              });

              const dateDiff = dateDiffInMinutes(`${item.month}-01 00:00:00`, `${formatDate(new Date(),'month')}-01 00:00:00`);

              const isExpird = dateDiff > 0;

              if(hasCapacity && !isExpird) {
                availableDates.push(item.month)
              }
            })
          });
          break;
        default:
          break;
      }

      return _unionWith(availableDates, _isEqual);
    },
    isDateTimesLoading() {
      return Object.values(this.loadingDateTimesData).some(item => {
        return item
      })
    }
  },
  watch: {
    'selectedValue.groupSize': {
      handler() {
        if(this.selectedValue.date) {
          const dateMap = {
            'light': {
              year: new Date().getFullYear(),
              month: 1,
            },
            'activity': {
              year: this.selectedValue.date.toString().substr(0, 4),
              month: this.selectedValue.date.toString().substr(-2, 2),
            },
          };
          const {year, month} = dateMap[this.formatProductType('category', this.$route.params.productType)];

          this.getCapacityOfProducts(year, month)
        }
      },
    },
  },
  mounted() {

    /**
     * 初始化 loadingDateTimesData 的預設值
     */
    const initLoadingDateTimesData = () => {
      this.products.forEach( ({ alias }) => {
        this.$set(this.loadingDateTimesData, alias, true);
      });
    };

    /**
     * 初始化 loadingDateTimesData 的預設值
     */
    const initSelectedDate = () => {
      const dateMap = {
        'light': {
          year: new Date().getFullYear(),
          month: 1,
        },
        'activity': {
          year: this.selectedValue.date.toString().substr(0, 4),
          month: this.selectedValue.date.toString().substr(-2, 2),
        },
      };
      const {year, month} = dateMap[this.formatProductType('category', this.$route.params.productType)];

      this.getCapacityOfProducts(year, month)
        .then(() => {
          if (this.availableDates.length > 0) {
            const [firstAvailableDate] = this.availableDates;

            this.selectedValue.date = firstAvailableDate;
          }
        });
    };

    /**
     * 清空購物車
     */
    const clearCart = () => {
      this.$store.dispatch('booking/updateCart');
    };

    initLoadingDateTimesData();
    initSelectedDate();
    clearCart();
  },
  methods: {
    formatProductType,

    /**
     * 前往商品內容頁
     */
    handleGoToBookingProduct({ product, selectedTime }) {
      this.$store.dispatch('booking/updateCart', {
        ...this.selectedValue,
        time: selectedTime,
        params: {},
        product,
      });

      this.$router.push(this.formatLink('booking-product', { productAlias: product.alias }));
    },

    /**
     * 選擇日期
     */
    handleChangDate() {
      if(this.selectedValue.date) {
        const dateMap = {
          'light': {
            year: new Date().getFullYear(),
            month: 1,
          },
          'activity': {
            year: this.selectedValue.date.toString().substr(0, 4),
            month: this.selectedValue.date.toString().substr(-2, 2),
          },
        };
        const {year, month} = dateMap[this.formatProductType('category', this.$route.params.productType)];

        this.getCapacityOfProducts(year, month)
      }
    },

    /**
     * 取得商品庫存
     *
     * @param year {Number} yyyy
     * @param month {Number} m
     */
    async getCapacityOfProducts(year = new Date().getFullYear(), month = 1) {
      const groupSize = this.selectedValue.groupSize;
      const setProductLoading = (alias, value) => {
        this.$set(this.loadingDateTimesData, alias, value);
      };

      for(let i = 0; i < this.products.length; i ++) {
        const productAlias = this.products[i].alias;
        const loadedAlias = `${year}&groupSize:${groupSize}&alias:${productAlias}`;
        const isLoaded = this.loadedDateTimesDataGroup.includes(loadedAlias);

        setProductLoading(productAlias, true);

        if(isLoaded) {
          setProductLoading(productAlias, false)
        } else {
          const formatDate = () => {
            if(this.formatProductType('category', this.$route.params.productType) === 'light') {
              return {
                startDate: `${year}-01-01`,
                endDate: `${parseInt(year.toString()) + 3}-01-01`,
              }
            }

            if(this.formatProductType('category', this.$route.params.productType) === 'activity') {
              return {
                startDate: `${year}-01-01`,
                endDate: `${parseInt(year.toString()) + 2}-12-31`,
              }
            }
          };

          await this.$store
            .dispatch('merchant/fetchProductCapacity', {
              merchantAlias: this.merchant.alias,
              productAlias,
              groupSize,
              productType: this.$route.params.productType,
              ...formatDate()
            })
            .then((dateTimes) => {
              const updateProductLoaded = (alias) => {
                this.loadedDateTimesDataGroup.push(alias);
              };

              const checkDefaultData = () => {
                if(!this.loadedDateTimesData[`groupSize:${groupSize}`]) {
                  this.$set(this.loadedDateTimesData, `groupSize:${groupSize}`, {});
                }
              };

              const setData = () => {
                const isDataExist = !this.loadedDateTimesData[`groupSize:${groupSize}`][productAlias];

                const setData = () => {
                  this.$set(this.loadedDateTimesData[`groupSize:${groupSize}`], productAlias, []);
                  this.$set(this.loadedDateTimesData[`groupSize:${groupSize}`], productAlias, dateTimes);
                };

                const updateData = () => {
                  dateTimes.forEach(item => {
                    this.loadedDateTimesData[`groupSize:${groupSize}`][productAlias].push(item);
                  });

                  if(this.formatProductType('category', this.$route.params.productType) === 'light') {
                    this.loadedDateTimesData[`groupSize:${groupSize}`][productAlias] = _unionBy(this.loadedDateTimesData[`groupSize:${groupSize}`][productAlias], 'year');
                  }else {
                    this.loadedDateTimesData[`groupSize:${groupSize}`][productAlias] = _unionBy(this.loadedDateTimesData[`groupSize:${groupSize}`][productAlias], 'month');
                  }
                };

                if(isDataExist)
                  setData();
                else
                  updateData();
              };

              updateProductLoaded(loadedAlias);
              setProductLoading(productAlias, false);
              checkDefaultData();
              setData();
            })
        }
      }

      return true;
    },

    /**
     * 取得商品時段
     *
     * @param alias {String}
     * @return {Object}
     */
    getProductDateTimesData(alias) {
      const dataTimesAliasGroup = this.loadedDateTimesData[`groupSize:${this.selectedValue.groupSize}`] || {};
      const dataTimes = alias in dataTimesAliasGroup ? dataTimesAliasGroup[alias] : [];
      const currentDataTimes = dataTimes.filter(item => {
        const typeMap = {
          'light': 'year',
          'activity': 'month',
        };
        const selectType = typeMap[this.formatProductType('category', this.$route.params.productType)];

        return item[selectType].toString() === this.selectedValue.date.toString()
      });

      return currentDataTimes.length > 0 ? currentDataTimes[0] : {}
    },

    /**
     * 格式化連結
     *
     * @param type {String}
     * @param data {Object}
     * @return {Object}
     */
    formatLink(type, data = {}) {
      const baseQuery = { language: this.$route.query.language };

      switch (type) {
        case 'booking-product':
          return {
            name: 'booking-product',
            params: {
              productId: data.productAlias,
              productType: this.$route.params.productType
            },
            query: { ...baseQuery },
          }
      }
    }
  },
}
</script>

<template>
  <Layout>
    <BaseContainer>
      <TheBanner/>
      <template v-if="products.length !== 0">
        <BaseSection>
          <BaseSubSection
            :title="$t(`product.${$route.params.productType}.TIME_AND_AMOUNT`/*請選擇年份(時間)與數量*/)"
          >
            <SelectDateSize
              :date.sync="selectedValue.date"
              :size.sync="selectedValue.groupSize"
              :available-dates="availableDates"
              :max-size="maxGroupSize"
              :loading="isDateTimesLoading"
              @select-date="handleChangDate"
            />
          </BaseSubSection>
        </BaseSection>
        <BaseSection
          :title="$t('global.SELECT_ITEM'/*選擇項目*/)"
        >
          <BaseSubSection
            class="product-wrapper"
          >
            <ProductItem
              v-for="product in products"
              ref="product"
              :key="product.alias"
              :data="product"
              :date-times="getProductDateTimesData(product.alias)"
              :date-loading="loadingDateTimesData[product.alias]"
              :select-date="selectedValue.date"
              @select-time="handleGoToBookingProduct"
            />
          </BaseSubSection>
        </BaseSection>
      </template>
      <ViewNull v-else />
    </BaseContainer>
  </Layout>
</template>
